module.exports = "/fonts/dripicons-v2.svg?835984438066bd8944a7692e331152a7";